<template>
  <div class="sscontainer-footer-footer moyen-paiement">
    <ul class="menu-paiements-footer">
      <li class="visa"><span class="invisible">Vous pouvez vous abonner en ligne à COOLOC avec une carte de paiement Visa</span>
      </li>
      <li class="mastercard"><span class="invisible">Vous pouvez vous abonner en ligne à COOLOC avec une carte de paiement MasterCard</span>
      </li>
      <li class="paypal"><span class="invisible">Vous pouvez vous abonner en ligne à COOLOC avec Paypal</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'footer-menus-payments',
}
</script>
